module.exports = __webpack_public_path__ + "media/images/fullscreen/root_homes-7ba00aadb98389dc5b4f6ae50b6cde15.jpg";